var map = {
	"./footer-links.de-CH.json": 1082,
	"./footer-links.de-DE.json": 1083,
	"./footer-links.en-CA.json": 1084,
	"./footer-links.en-GB.json": 1085,
	"./footer-links.en-IN.json": 1086,
	"./footer-links.en-ME.json": 1087,
	"./footer-links.en-US.json": 1088,
	"./footer-links.es-EM.json": 1089,
	"./footer-links.es-ES.json": 1090,
	"./footer-links.fr-BE.json": 1091,
	"./footer-links.fr-CA.json": 1092,
	"./footer-links.fr-CH.json": 1093,
	"./footer-links.nl-BE.json": 1094,
	"./footer-links.nl-NL.json": 1095,
	"./footer-links.pl-PL.json": 1096,
	"./footer-links.pt-BR.json": 1097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;